import { Link } from 'react-router-dom';
import { t } from 'ttag';
import imgAutokierratys from 'static/logos/autokierratys.png';
import ImgLogo from 'static/logos/delv.svg';
import './index.scss';

const PersonNavigator = () => (
    <nav className='person-navigator'>
        <div className='logo-container'>
            <Link to='/person' className='nav-logo-wrap'>
                <ImgLogo />
            </Link>
            <a href='https://autokierratys.fi/' target='_blank' rel='noopener noreferrer' className='nav-logo-wrap'>
                <img src={imgAutokierratys} alt='Suomen Autokierrätys' />
            </a>
        </div>
        <Link to='/logout' className='logout'>
            {t`LOGOUT`}
        </Link>
    </nav>
);

export default PersonNavigator;
